<template>
    <main-content>
        <div class="bg-white p-2 shadow-sm">
            <kt-datatable ref="datatable" v-bind="datatableProps">
            </kt-datatable>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import {ApiUrl} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import columns from "./datatable/transaction-columns";
    import actions from "./datatable/settlement-actions";

    export default {
        components: {
            mainContent,
        },
        computed: {
            datatableProps() {
                return {
                    id: "wallet_transactions_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path(`wallet/day/settlement-list/${this.$route.params.hashid}`),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: res => {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actions,
                }
            },
        },
    }
</script>
